<aside class="flex flex-col h-screen w-full bg-white overflow-hidden relative sidebar-crm">
  <!-- Franja decorativa izquierda -->
  <div class="absolute left-0 top-0 bottom-0 w-[5px] sidebar-left-stripe"></div>

  <!-- Contenedor superior (Rojo) que incluye Logo y Home -->
  <div class="bg-[#A50104] shadow-sm flex flex-col pt-5">
    <!-- Logo -->
    <div class="flex items-center gap-3 px-5 pl-6 mb-5">
      <img src="assets/smart_crm/logo_index.jpeg" alt="Smart Global Sales" routerLink="/home"
        class="w-10 h-10 rounded-lg cursor-pointer transition-transform hover:scale-105 object-cover bg-white p-0.5" />
      <span routerLink="/home"
        class="text-white text-[14px] font-bold cursor-pointer leading-[1.1] flex flex-col justify-center">
        <span>Smart</span>
        <span>Global</span>
        <span>Sales</span>
      </span>
    </div>

    <!-- Home Link -->
    <div class="w-full">
      <a routerLink="/home" routerLinkActive="bg-[#8B0103] shadow-inner" [routerLinkActiveOptions]="{ exact: true }"
        class="flex items-center gap-2.5 px-6 py-3 rounded-none text-white hover:bg-[#8B0103]/80 transition-all duration-150 text-[14px] cursor-pointer"
        (click)="navigateAndClose('/home')">
        <mat-icon class="text-[18px] w-[18px] h-[18px] shrink-0 text-white">home</mat-icon>
        <span class="font-medium truncate">Home</span>
      </a>
    </div>
  </div>

  <!-- Navegación -->
  <nav class="flex-1 overflow-y-auto select-none mobile-nav-content py-1">
    <ul class="space-y-0.5">
      <ng-container *ngFor="let section of visibleSections">
        <!-- Etiqueta de sección -->
        <li *ngIf="section.label"
          class="mt-4 mb-1 px-6 py-1.5 bg-[#A501041A] text-[12px] font-bold text-[#A50104] first:mt-1">
          {{ section.label }}
        </li>

        <!-- Ítems -->
        <ng-container *ngFor="let item of section.items">
          <li class="px-3">
            <!-- Enlace simple -->
            <a *ngIf="!item.children; else hasChildren" [routerLink]="isExternalRoute(item.route) || item.route === 'action:chat' ? null : item.route" [attr.href]="isExternalRoute(item.route) ? getDynamicUrl(item.route) : null" [attr.target]="isExternalRoute(item.route) ? '_blank' : null" [attr.rel]="isExternalRoute(item.route) ? 'noopener noreferrer' : null" routerLinkActive="active-menu-item"
              [routerLinkActiveOptions]="{ exact: true }"
              class="flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-[#444] hover:bg-[#A501041A] hover:text-[#A50104] transition-all duration-150 text-[13px] menu-item-mobile w-full cursor-pointer"
              (click)="navigateAndClose(item.route)">
              <mat-icon class="text-base shrink-0 text-[#888]">{{ item.icon }}</mat-icon>
              <span class="font-medium truncate">{{ item.label }}</span>
            </a>

            <!-- Con submenú -->
            <ng-template #hasChildren>
              <button (click)="toggle(item)"
                class="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-[#444] hover:bg-[#A501041A] hover:text-[#A50104] transition-colors text-[13px]"
                [class.active-menu-item]="isParentActive(item)">
                <mat-icon class="text-base shrink-0 text-[#888]">{{ item.icon }}</mat-icon>
                <span class="flex-1 text-left truncate font-medium">{{ item.label }}</span>
                <mat-icon class="text-base shrink-0 text-[#aaa]">
                  {{ isOpen(item) ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </button>

              <ul *ngIf="isOpen(item)" class="space-y-0.5 mt-0.5 w-full">
                <li *ngFor="let child of item.children">
                  <a [routerLink]="child.route" routerLinkActive="active-menu-item"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="flex items-center gap-2.5 pl-10 pr-3 py-2 rounded-lg text-[#666] hover:bg-[#A501041A] hover:text-[#A50104] transition-all duration-150 text-[13px] w-full"
                    (click)="navigateAndClose(child.route)">
                    <mat-icon class="text-sm shrink-0 text-[#999]">{{ child.icon }}</mat-icon>
                    <span class="truncate">{{ child.label }}</span>
                  </a>
                </li>
              </ul>
            </ng-template>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </nav>

  <!-- Botón Cerrar sesión -->
  <div
    class="mobile-menu-logout md:relative md:bottom-auto md:left-auto md:right-auto flex justify-center p-3 pl-6 border-t border-gray-200 z-10"
    *ngIf="isAuthorized">
    <button mat-raised-button (click)="onSignOut()"
      class="w-full rounded-lg text-white bg-[#A50104] font-semibold tracking-wide text-[12px] uppercase transition-all hover:bg-[#8B0103] py-2 shadow-sm flex items-center justify-center gap-2">
      Cerrar sesión
      <mat-icon class="text-base !text-white">arrow_forward</mat-icon>
    </button>
  </div>
</aside>